<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <img :src="caution" height="25px" />
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">
            <valueLabelSection :titleLabel="confirmWord"></valueLabelSection>
            <valueLabelSection
              :titleLabel="companyIdTitle"
              :valueLabel="corporation.companyId"
            ></valueLabelSection>
            <valueLabelSection
              :titleLabel="companyNameTitle"
              :valueLabel="corporation.companyName"
            ></valueLabelSection>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('stayClose')"
            />
            <input
              type="button"
              :value="deleteButton"
              class="delete_button"
              @click="showPasswordInputModal = true"
            />
          </div>
          <div class="complete_modal_window" v-if="showPasswordInputModal">
            <passwordInputModalWindow
              @close="stayClose"
              @ok="deleteCorporations"
            >
            </passwordInputModalWindow>
          </div>
          <div class="complete_modal_window" v-if="showCompleteModal">
            <finishModalWindow :question="completeWord" @close="close">
            </finishModalWindow>
          </div>
          <div class="modal_window" v-if="showFailureModal">
            <finishModalWindow :question="failureWord" @close="stayClose">
            </finishModalWindow>
          </div>
          <div class="loading_modal_window" v-if="showloadingModal">
            <loadingModalWindow @close="close"> </loadingModalWindow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import valueLabelSection from './modalwindowComponents/valueLabelSection.vue'
import passwordInputModalWindow from './passwordInputModalWindow.vue'
import confirmModalWindow from './confirmModalWindow.vue'
import finishModalWindow from './finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      caution: require('../../../../img/caution.png'),
      title: 'テナント削除確認',
      companyIdTitle: 'テナントID:',
      companyNameTitle: 'テナント名:',
      cancelButton: 'キャンセル',
      deleteButton: '削除',
      completeWord: '',
      failureWord: '',
      confirmWord: '以下のテナントを削除してもよろしいですか？',
      showPasswordInputModal: false,
      showCompleteModal: false,
      showFailureModal: false,
      showloadingModal: false
    }
  },
  components: {
    valueLabelSection,
    passwordInputModalWindow,
    confirmModalWindow,
    finishModalWindow,
    loadingModalWindow
  },
  computed: {
    backgroundColor() {
      if (
        this.showCompleteModal === true ||
        this.showConfirmModal === true ||
        this.showFailureModal === true ||
        this.showPasswordInputModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    corporation() {
      return this.$store.state.corporations.corporation
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    }
  },
  methods: {
    close(e) {
      this.$emit('close')
    },
    stayClose(e) {
      this.showFailureModal = false
      this.showConfirmModal = false
      this.showPasswordInputModal = false
    },
    async deleteCorporations() {
      this.showloadingModal = true
      this.showConfirmModal = false
      this.showPasswordInputModal = false
      try {
        await this.$store.dispatch(
          'corporations/deleteCorporations',
          this.corporation.companyId
        )
        this.completeWord = '削除しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_130002
        this.createErrorMessage(error, eventNumber, 'MSGCRD0048')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>
<style scoped>
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 391px;
  padding-top: 40px;
}
.modal_container {
  height: 370px;
}
.modal_header {
  background-color: #33ccff;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/modalWindow/corporationDeleteModalWindow.vue